import React, { Fragment, Component } from 'react';
import propTypes from 'prop-types';
import Input from './../Input';
import Span from './../Span';
import classNames from 'classnames';
import { omit } from 'lodash'
import { formatMoney, checkUndefine } from '../../../../../helpers/functions';
import $ from 'jquery';
export default class EditableText extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editing: false,
            width: undefined,
        };
        this.input = React.createRef();
        this.view = React.createRef();
    }

    componentDidMount() {
        setTimeout(this.setInputWidth);
    }

    toggleEdit = (e) => {
        if (!this.props.editable) {
            return this.props.onClick && this.props.onClick(e)
        }
        const editing = !this.state.editing;
        this.setState({ editing });
    };

    setInputWidth = () => {
        if (this.view.current && this.input.current) {
            const width = $(this.view.current).outerWidth();
            this.setState({ width })
        }
    }

    onBlur = e => {
        this.onSave(e.target.value);
        this.toggleEdit();
        return this.props.onBlur(e);
    };

    onSave = (value) => {
        const { onSave } = this.props;
        const saved = onSave(value);
        if(saved){
            setTimeout(this.saveAnimation);
        }
    }

    saveAnimation = () => {
        if (this.view.current) {
            const view = $(this.view.current);
            view.clearQueue().addClass("highlight").queue(function (next) {
                $(this).addClass("highlight"); next();
            }).delay(200).queue(function (next) {
                $(this).removeClass("highlight"); next();
            });
        }
    }

    renderValue = () => {
        const { type, value } = this.props;
        if (!type) return value;
        switch (type.toLowerCase()) {
            case 'currency':
                return checkUndefine(formatMoney(value, false));
            default:
                return value
        }
    }

    render() {
        const { editing, width } = this.state;
        const {
            t, value, editable, onChange,
            className, prefix, suffix,
            ...restProps
        } = this.props;
        return editing ? (
            <Input
                {...omit(restProps, ['tReady', 'onSave'])}
                ref={this.input}
                autoFocus
                value={value}
                onChange={onChange}
                onBlur={this.onBlur}
                prefix={prefix} suffix={suffix}
                onPressEnter={this.onBlur}
                className={classNames("hms-editable-text", className, { editing })}
                width={width}
            />
        ) : (
                <Span ref={this.view} onClick={this.toggleEdit}
                    className={classNames("hms-editable-text ant-input flex-center", className, {
                        viewing: true,
                        'cursor-text': editable,
                        'justify-end': this.props.type === 'currency',
                    })}
                >{prefix}{this.renderValue()} {suffix}</Span>
            )
    }
}
EditableText.propTypes = {
    editable: propTypes.bool,
    ...Input.propTypes,
}
EditableText.defaultProps = {
    editable: true,
    onChange: e => { },
    onBlur: e => { },
    onSave: value => { },
}